// ============================================================================
// Table Columns: ContactCodes
// Key: contactCodes
// Generated file. Do not edit manually.
// ============================================================================

// #region Imports
import {
	cellRenderer,
	type EntityTableConfig,
} from '../../entity-config-runtime/entity-table-config'
import type { ContactCodeResponse } from '../api/backstage.schemas'
// #endregion

// #region Entity List Columns
export const contactCodesListColumnsConfig = {
	columns: [
		'name',
		cellRenderer('code', 'number'),
		cellRenderer('treeCount', 'number'),
		'modifiedBy',
		cellRenderer('modifiedUtc', 'dateTime'),
	],
	actions: [
		{
			type: 'link',
			id: 'id',
			label: 'tables_actions_detail',
			icon: 'ArrowRight',
			style: 'link',
			href: (row: ContactCodeResponse) => `/contactCodes/${row.id}/details`,
		},
	],
} as const satisfies EntityTableConfig<ContactCodeResponse>
// #endregion

// #region Columns Config Export
export const contactCodesColumnsConfig = {
	list: contactCodesListColumnsConfig,
} as const
// #endregion
